/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/media-has-caption */
import QrScanner from 'qr-scanner';
import React, { useEffect, useRef } from 'react';
import './QrScanner.less';

interface QRScannerProps {
    onScan: (data: any) => void;
}

const QRScanner: React.FC<QRScannerProps> = ({ onScan }) => {
    const videoElementRef = useRef<HTMLVideoElement>(null);

    useEffect(() => {
        const video: HTMLVideoElement | null = videoElementRef.current;
        if (!video) return;
        const qrScanner = new QrScanner(
            video,
            (result) => {
                onScan(result.data);
            },
            {
                returnDetailedScanResult: true,
                highlightScanRegion: true,
                highlightCodeOutline: true,
            }
        );
        qrScanner.start().catch();

        return () => {
            qrScanner.stop();
            qrScanner.destroy();
        };
    }, []);

    return (
        <div className="qr-scanner-container">
            <video className="qrVideo" ref={videoElementRef} />
        </div>
    );
};

export default QRScanner;
